<template>
  <div id="reminderList">
    <a-list  itemLayout="vertical" :dataSource="reminderList" :pagination="listPagination" id="reminderListItems">
      <a-list-item slot="renderItem" slot-scope="item,index">
        <a-list-item-meta>
          <a-avatar
            icon="user"
            slot="avatar"
            class="userImage"
            :src="getImageUrl(item.createrId)"
          />
          <div slot="title">
            <a-row class="reminderTitle">
              <a-col :span="20" style="font-size: 14px;color: #4D4D4D;font-weight: bold;">{{item.createName}}</a-col>
              <a-col :span="4" @click="editReminder(item)" v-show="showEditButtons">
                <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
              </a-col>
            </a-row>
            <a-row class="reminderContentDiv">
              <div style="display: flex;margin-bottom: 5px;">
                <div>
                  <div class="follower_type">{{$t('deal.dealDetails.customerRecordTypes.' + item.taskType)}}</div>
                </div>
                <div style="flex:1;text-align: right;font-size: 12px;color: #999999;">
                  {{$t('reminder.startTime') + ' : '}}{{item.startTime | dayjs('YYYY-MM-DD HH:mm')}}
                </div>
              </div>
              <a-row style="font-size: 12px;color: #333333;word-break: break-all">
                {{item.content}}
              </a-row>
            </a-row>
          </div>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
  import reminderApi from '@/api/work/reminder'
  export default {
    name: 'reminderList',
    props: {
      showEditButtons:{
        type:Boolean,
        default: true
      },
      reminderQuery:{
        type: Object,
        default: ()=>{ return null }
      },
    },
    data() {
      return {
        reminderList:[],
        listPagination: {
          onChange: page => {
            this.listPagination.current = page
            this.queryReminderList()
          },
          hideOnSinglePage:true,
          size:'small',
          current: 1,
          pageSize: 5,
        },
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      editReminder(value){
        this.$emit('editReminder',value)
      },
      getImageUrl(userId){
        return this.$util.getHeadImgUrl(userId)
      },
      init(){
        this.queryReminderList()
      },
      queryReminderList(){
        this.reminderQuery.current = this.listPagination.current;
        this.reminderQuery.size = this.listPagination.pageSize;
        reminderApi.selectByBusinessId(this.reminderQuery).then(res=>{
          if(res.code == 1){
            this.reminderList = res.data.records
            this.listPagination.total = res.data.total
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .ant-list-split .ant-list-item{
    border-bottom: 0px !important;
  }
  .ant-list-vertical .ant-list-item-meta{
    margin-bottom: 0px !important;
  }
  .ant-list-vertical .ant-list-item-meta-title{
    margin-bottom: 4px !important;
  }
  .reminderContentDiv{
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #E7E7E7;
  }
  .follower_type{
    line-height: 20px;
    padding: 1px 11px;
    font-size: 12px;
    color: #95AAC9;
    background: #F9FBFD;
    border: 1px solid #DEE4EC;
  }
  .reminderTitle{
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999999;
    margin-bottom: 10px;
  }
  .edit_icon{
    font-size: 18px;
    float:right;
    cursor:pointer;
  }
</style>